import type { CurrentUserSearchCriteria, CurrentUserSearchCriteriaResponse } from "./types"
import type { NextRequest } from "@/modules/fetch/types"

import { getApiUrl } from "@/modules/api/api"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"
import { DEFAULT_STORAGE_DURATION } from "@/modules/serverStorage/constants"

import { CURRENT_USER_SEARCH_CRITERIA_ENDPOINT, CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY } from "./constants"

type GetCurrentUserSearchCriteriaParams = {
  req?: NextRequest
}

export const getCurrentUserSearchCriteria = async ({
  req,
}: GetCurrentUserSearchCriteriaParams): Promise<CurrentUserSearchCriteria> =>
  fetcher(CURRENT_USER_SEARCH_CRITERIA_ENDPOINT, {
    nextRequest: req,
    requestInit: {
      method: "POST",
    },
    serviceDomain: "KRAKEND_API",
    storageDuration: DEFAULT_STORAGE_DURATION,
    storageKey: `${CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY}`,
  })
    .then(
      getResultFromResponse<CurrentUserSearchCriteriaResponse>({
        transformResult: toCamelCaseKeys<CurrentUserSearchCriteriaResponse>,
      })
    )
    .then(({ searchCriteria }) => searchCriteria)
    .catch(handleFetchError(getApiUrl({ path: CURRENT_USER_SEARCH_CRITERIA_ENDPOINT, serviceDomain: "KRAKEND_API" })))
